module.exports = __webpack_public_path__ + "img/1586478792.13aa9e1e.jpg";